import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_SHIFT_ASSIGNMENT_ROUTER, API_SHIFT_ROUTER, API_DEPARTMENT_ROUTER } from "../../../services/api-config";
// 💡 SỬA: Thay thế ShiftCalendarPagination bằng type dữ liệu thực tế (Mảng)
import { CreateAssignmentPayload, DeleteAssignmentPayload, EmployeeShiftCalendar, RemoveAssignmentsPayload, ShiftListFilters } from "../types/shift-assignment.types"; 

export enum ShiftStatusCode {
  INACTIVE = 2,
  ACTIVE = 1,
}

export interface Shift {
    id: string; 
    name: string;
    code: string;
    start_time: string;
    end_time: string;
    break_time: number;
    max_employees: number;
    status: number;
    description: string;
    normalize_name: string;
    created_at: string;
    updated_at: string;
}

export interface ShiftListResponse {
  list: Shift[];
  total_record?: number;
  limit?: number;
}

export interface CreateAssignmentResponse{
  massage: string;
}

export interface DepartmentListFilters {
  status?: number;           // 1 active, 0 inactive, -1 all
  company_id?: number;
  parent_department_id?: number;
  keyword?: string;
}

export interface Department {
  id: number;
  name: string;
  status: DepartmentStatusCode;
}

export enum DepartmentStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
}


export interface DepartmentListResponse {
  list: Department[];
  total_record?: number;
  limit?: number;
}

const ShiftAssigmentService = {
  listCalendar: () => {
    // ✅ FIX: Generic type là EmployeeShiftCalendar[] (mảng dữ liệu thực tế)
    const { request, baseResponse, loading } = useFetchData.Get<EmployeeShiftCalendar[]>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    
    return {
      fetch: (params: ShiftListFilters = {  }) =>
        request({
          endPoint: API_SHIFT_ASSIGNMENT_ROUTER.API_ASSIGMENT_CALENDAR,
          data: params,
        }),
      
      // baseResponse giờ có type là EmployeeShiftCalendar[] | null
      response: baseResponse, 
      loading: loading,
    }
  },
  createShiftAssignments: () => {
    const { request, baseResponse, loading } = useFetchData.Post<CreateAssignmentResponse>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (id: string, payload: CreateAssignmentPayload) =>
        request({
          endPoint: API_SHIFT_ASSIGNMENT_ROUTER.API_ASSIGMENT_CREATE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  deleteShiftAssignment: () => {
    const { request, baseResponse, loading } = useFetchData.Post<CreateAssignmentResponse>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (id: string, payload: DeleteAssignmentPayload) =>
        request({
          endPoint: API_SHIFT_ASSIGNMENT_ROUTER.API_ASSIGMENT_DELETE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  removeShiftAssignments: () => {
    const { request, baseResponse, loading } = useFetchData.Post<CreateAssignmentResponse>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (id: string, payload: RemoveAssignmentsPayload) =>
        request({
          endPoint: API_SHIFT_ASSIGNMENT_ROUTER.API_ASSIGMENT_REMOVE(),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  listShift: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ShiftListResponse>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (params: ShiftListFilters = { status: -1 }) =>
        request({
          endPoint: API_SHIFT_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  listDepartment: () => {
    const { request, baseResponse, loading } = useFetchData.Get<DepartmentListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: DepartmentListFilters = { status: -1 }) =>
        request({
          endPoint: API_DEPARTMENT_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  }
}

export default ShiftAssigmentService;